// extracted by css-extract-rspack-plugin
export default {"toggle":"toggle-zxGfXk","option":"option-O0z_JA"};